import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { MobileCtaBar } from "../components/MobileCtaBar";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { ServicesGrid } from "../components/ServicesGrid";
import { ReviewsHub } from "../components/ReviewsHub";
import { Pillars } from "../components/Pillars";
import { BeforeAfterGallery } from "../components/BeforeAfterGallery";
import { CaseStudy } from "../components/CaseStudy";
import { ActiveProjects } from "../components/ActiveProjects";
import { YieldCalculator } from "../components/YieldCalculator";
import { LandownerPortal } from "../components/LandownerPortal";
import { LifestyleHub } from "../components/LifestyleHub";
import { QueryWizard } from "../components/QueryWizard";
import { Footer } from "../components/Footer";

const HOME_TITLE = "JAI HOMES | Licensed Master Builder NSW — Homes, Childcare & Commercial";
const HOME_DESC =
  "Premier NSW master builder (Licence No. 476816C) specializing in custom residential homes, multi-unit developments, turnkey childcare centres, shop fit-outs, and medical facilities.";

export default function Home() {
  useEffect(() => {
    document.title = HOME_TITLE;
    const el = document.head.querySelector('meta[name="description"]');
    if (el) el.setAttribute("content", HOME_DESC);
  }, []);

  return (
    <div className="bg-[#0A0E17] min-h-screen" data-testid="home-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <ServicesGrid />
        <ReviewsHub />
        <Pillars />
        <BeforeAfterGallery />
        <CaseStudy />
        <ActiveProjects />
        <YieldCalculator />
        <LandownerPortal />
        <LifestyleHub />
        <QueryWizard />
      </main>
      <MobileCtaBar />
      <Footer />
    </div>
  );
}
